
// vue
import { defineComponent } from 'vue';

// firebase
import 'firebase/firestore';

// molecules
import HeaderMenu from '@/components/molecules/HeaderMenu.vue';

export default defineComponent({
  name: 'ExpiredScreen',
  components: {
    HeaderMenu,
  },
  setup() {
    return {};
  },
});
